// extracted by mini-css-extract-plugin
export default {"div":"Pagination_div__RS-nz","prev":"Pagination_prev__qf+19","next":"Pagination_next__gia39","label":"Pagination_label__HyanG"};